__turbopack_context__.v({
  "button": "-ZwxzG_button",
  "icon": "-ZwxzG_icon",
  "input": "-ZwxzG_input",
  "placeholder": "-ZwxzG_placeholder",
  "stepper": "-ZwxzG_stepper",
});
